export default "__VITE_ASSET__BG0vdn4X__"